var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path, _path2, _path3, _path4, _circle2, _path5, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1546,
    height: 272,
    viewBox: "0 0 1546 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 159.798,
    cy: 133.799,
    r: 101.649,
    transform: "rotate(-180 159.798 133.799)",
    fill: "#FFB800",
    stroke: "#091C4A",
    strokeWidth: 8.29778
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.835,
    y: 184.998,
    width: 114.978,
    height: 2.52006,
    rx: 1.26003,
    transform: "rotate(-60.1544 131.835 184.998)",
    fill: "#091C4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.365,
    y: 170.061,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(-15 141.365 170.061)",
    fill: "#091C4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136.671,
    y: 177.488,
    width: 2.52006,
    height: 9.81448,
    rx: 0.981449,
    transform: "rotate(-15 136.671 177.488)",
    fill: "#091C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141.449,
    y: 168.299,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(75 141.449 168.299)",
    fill: "#091C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137.376,
    y: 175.797,
    width: 2.52006,
    height: 9.81448,
    rx: 0.981449,
    transform: "rotate(75 137.376 175.797)",
    fill: "#091C4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 182.166,
    y: 100.693,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(165 182.166 100.693)",
    fill: "#091C4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 186.86,
    y: 93.2656,
    width: 2.52006,
    height: 9.81448,
    rx: 0.981449,
    transform: "rotate(165 186.86 93.2656)",
    fill: "#091C4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 182.082,
    y: 102.455,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(-105 182.082 102.455)",
    fill: "#091C4A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 186.157,
    y: 94.957,
    width: 2.52006,
    height: 9.81448,
    rx: 0.981449,
    transform: "rotate(-105 186.157 94.957)",
    fill: "#091C4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 188.518,
    y: 186.621,
    width: 114.978,
    height: 2.52006,
    rx: 1.26003,
    transform: "rotate(-119.371 188.518 186.621)",
    fill: "#091C4A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 180.563,
    y: 170.789,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(-74.2165 180.563 170.789)",
    fill: "#091C4A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 184.545,
    y: 178.625,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(-74.2165 184.545 178.625)",
    fill: "#091C4A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 179.093,
    y: 169.812,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(15.7835 179.093 169.812)",
    fill: "#091C4A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 183.448,
    y: 177.152,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(15.7835 183.448 177.152)",
    fill: "#091C4A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 141.845,
    y: 100.227,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(105.784 141.845 100.227)",
    fill: "#091C4A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 137.865,
    y: 92.3906,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(105.784 137.865 92.3906)",
    fill: "#091C4A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 143.315,
    y: 101.201,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(-164.216 143.315 101.201)",
    fill: "#091C4A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 138.96,
    y: 93.8613,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(-164.216 138.96 93.8613)",
    fill: "#091C4A"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 219.419,
    y: 136.877,
    width: 114.978,
    height: 2.52006,
    rx: 1.26003,
    transform: "rotate(179.846 219.419 136.877)",
    fill: "#091C4A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 201.715,
    y: 136.094,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(-135 201.715 136.094)",
    fill: "#091C4A"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 210.496,
    y: 136.443,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(-135 210.496 136.443)",
    fill: "#091C4A"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 200.146,
    y: 136.898,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(-45 200.146 136.898)",
    fill: "#091C4A"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 208.677,
    y: 136.68,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(-45 208.677 136.68)",
    fill: "#091C4A"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 121.236,
    y: 135.434,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(45 121.236 135.434)",
    fill: "#091C4A"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 112.455,
    y: 135.084,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(45 112.455 135.084)",
    fill: "#091C4A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 122.808,
    y: 134.631,
    width: 2.52006,
    height: 13.4695,
    rx: 1.26003,
    transform: "rotate(135 122.808 134.631)",
    fill: "#091C4A"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 114.274,
    y: 134.848,
    width: 2.52006,
    height: 9.81449,
    rx: 0.981449,
    transform: "rotate(135 114.274 134.848)",
    fill: "#091C4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.443 86.0057L176.015 109.339L176.37 109.907L177.04 109.931L204.532 110.883L191.611 135.169L191.296 135.761L191.611 136.353L204.532 160.638L177.04 161.591L176.37 161.614L176.015 162.183L161.443 185.516L146.872 162.183L146.517 161.614L145.847 161.591L118.354 160.638L131.275 136.353L131.59 135.761L131.275 135.169L118.354 110.883L145.847 109.931L146.517 109.907L146.872 109.339L161.443 86.0057Z",
    fill: "#091C4A",
    stroke: "#091C4A",
    strokeWidth: 2.52006
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.55 110.504L176.28 126.189L176.312 126.859L176.884 127.207L190.3 135.365L177.083 143.84L176.518 144.202L176.503 144.872L176.146 160.569L162.198 153.36L161.602 153.052L161.014 153.374L147.241 160.914L146.51 145.229L146.479 144.56L145.906 144.211L132.49 136.054L145.708 127.578L146.273 127.217L146.288 126.546L146.645 110.849L160.593 118.058L161.189 118.366L161.777 118.044L175.55 110.504Z",
    fill: "#091C4A",
    stroke: "#091C4A",
    strokeWidth: 2.52006
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.093 119.331L165.808 126.553L166.175 127.114L166.845 127.124L175.469 127.249L171.572 134.943L171.269 135.541L171.596 136.127L175.8 143.657L167.188 144.13L166.519 144.167L166.175 144.742L161.755 152.148L157.04 144.926L156.674 144.365L156.003 144.355L147.38 144.231L151.276 136.536L151.579 135.938L151.253 135.353L147.049 127.822L155.661 127.35L156.33 127.313L156.673 126.737L161.093 119.331Z",
    stroke: "#091C4A",
    strokeWidth: 2.52006
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.714 127.908L165.97 132.29L166.009 132.959L166.586 133.301L170.363 135.538L166.695 137.95L166.135 138.318L166.128 138.989L166.079 143.378L162.157 141.408L161.557 141.107L160.973 141.436L157.148 143.589L156.892 139.207L156.853 138.537L156.276 138.196L152.499 135.959L156.167 133.547L156.727 133.178L156.734 132.508L156.783 128.119L160.705 130.088L161.305 130.389L161.889 130.061L165.714 127.908Z",
    stroke: "#091C4A",
    strokeWidth: 2.52006
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.94,
    cy: 134.723,
    r: 14.6026,
    transform: "rotate(-180 161.94 134.723)",
    fill: "#FFB800",
    stroke: "#091C4A",
    strokeWidth: 1.19203
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.56 181L1066.96 93.5H1093.56L1078.16 181H1051.56ZM1047.36 180.58L988 174.28H1048.48L1047.36 180.58ZM1052.12 153.56L992.76 147.26H1053.24L1052.12 153.56ZM1054.5 140.12L995.14 133.82H1055.62L1054.5 140.12ZM1056.88 126.68L997.52 120.38H1058L1056.88 126.68ZM1059.26 113.24L999.9 106.94H1060.24L1059.26 113.24ZM1049.74 167L990.38 160.7H1050.86L1049.74 167ZM1061.5 99.8L1002.28 93.5H1062.62L1061.5 99.8Z",
    fill: "#000749"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1042.82,
    y: 194.225,
    width: 138.225,
    height: 3.0296,
    rx: 1.5148,
    transform: "rotate(-60.1544 1042.82 194.225)",
    fill: "#091C4A"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1054.28,
    y: 176.268,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(-15 1054.28 176.268)",
    fill: "#091C4A"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1048.63,
    y: 185.195,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(-15 1048.63 185.195)",
    fill: "#091C4A"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1054.38,
    y: 174.146,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(75 1054.38 174.146)",
    fill: "#091C4A"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1049.48,
    y: 183.16,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(75 1049.48 183.16)",
    fill: "#091C4A"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1103.33,
    y: 92.8691,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(165 1103.33 92.8691)",
    fill: "#091C4A"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1108.97,
    y: 83.9414,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(165 1108.97 83.9414)",
    fill: "#091C4A"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1103.23,
    y: 94.9902,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(-105 1103.23 94.9902)",
    fill: "#091C4A"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1108.13,
    y: 85.9766,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(-105 1108.13 85.9766)",
    fill: "#091C4A"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1110.96,
    y: 196.176,
    width: 138.225,
    height: 3.0296,
    rx: 1.5148,
    transform: "rotate(-119.371 1110.96 196.176)",
    fill: "#091C4A"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1101.4,
    y: 177.143,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(-74.2165 1101.4 177.143)",
    fill: "#091C4A"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1106.18,
    y: 186.561,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(-74.2165 1106.18 186.561)",
    fill: "#091C4A"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.63,
    y: 175.965,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(15.7835 1099.63 175.965)",
    fill: "#091C4A"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1104.87,
    y: 184.791,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(15.7835 1104.87 184.791)",
    fill: "#091C4A"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1054.86,
    y: 92.3164,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(105.784 1054.86 92.3164)",
    fill: "#091C4A"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1050.07,
    y: 82.8984,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(105.784 1050.07 82.8984)",
    fill: "#091C4A"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1056.62,
    y: 93.4902,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(-164.216 1056.62 93.4902)",
    fill: "#091C4A"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1051.39,
    y: 84.666,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(-164.216 1051.39 84.666)",
    fill: "#091C4A"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1148.11,
    y: 136.369,
    width: 138.225,
    height: 3.0296,
    rx: 1.5148,
    transform: "rotate(179.846 1148.11 136.369)",
    fill: "#091C4A"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1126.83,
    y: 135.428,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(-135 1126.83 135.428)",
    fill: "#091C4A"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1137.39,
    y: 135.852,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(-135 1137.39 135.852)",
    fill: "#091C4A"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1124.94,
    y: 136.398,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(-45 1124.94 136.398)",
    fill: "#091C4A"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1135.2,
    y: 136.137,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(-45 1135.2 136.137)",
    fill: "#091C4A"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1030.08,
    y: 134.643,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(45 1030.08 134.643)",
    fill: "#091C4A"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1019.52,
    y: 134.219,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(45 1019.52 134.219)",
    fill: "#091C4A"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1031.97,
    y: 133.672,
    width: 3.0296,
    height: 16.1929,
    rx: 1.5148,
    transform: "rotate(135 1031.97 133.672)",
    fill: "#091C4A"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 1021.71,
    y: 133.934,
    width: 3.0296,
    height: 11.7989,
    rx: 1.17989,
    transform: "rotate(135 1021.71 133.934)",
    fill: "#091C4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.41 75.2113L1095.93 103.262L1096.36 103.946L1097.16 103.973L1130.21 105.119L1114.68 134.315L1114.3 135.026L1114.68 135.738L1130.21 164.934L1097.16 166.079L1096.36 166.107L1095.93 166.791L1078.41 194.841L1060.9 166.791L1060.47 166.107L1059.66 166.079L1026.61 164.934L1042.15 135.738L1042.52 135.026L1042.15 134.315L1026.61 105.119L1059.66 103.973L1060.47 103.946L1060.9 103.262L1078.41 75.2113Z",
    fill: "#091C4A",
    stroke: "#091C4A",
    strokeWidth: 3.0296
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.37 104.666L1096.25 123.521L1096.29 124.326L1096.98 124.745L1113.11 134.552L1097.22 144.741L1096.54 145.176L1096.52 145.982L1096.09 164.853L1079.32 156.186L1078.6 155.816L1077.9 156.203L1061.34 165.267L1060.46 146.411L1060.42 145.606L1059.74 145.188L1043.61 135.381L1059.5 125.192L1060.18 124.757L1060.19 123.951L1060.62 105.08L1077.39 113.747L1078.11 114.117L1078.82 113.73L1095.37 104.666Z",
    fill: "#091C4A",
    stroke: "#091C4A",
    strokeWidth: 3.0296
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.99 115.277L1083.66 123.959L1084.1 124.633L1084.91 124.645L1095.27 124.795L1090.59 134.045L1090.23 134.764L1090.62 135.468L1095.67 144.521L1085.32 145.089L1084.51 145.133L1084.1 145.825L1078.79 154.729L1073.12 146.047L1072.68 145.372L1071.87 145.36L1061.51 145.21L1066.19 135.96L1066.55 135.241L1066.16 134.538L1061.11 125.484L1071.46 124.916L1072.27 124.872L1072.68 124.18L1077.99 115.277Z",
    stroke: "#091C4A",
    strokeWidth: 3.0296
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.55 125.585L1083.85 130.853L1083.9 131.658L1084.59 132.068L1089.13 134.757L1084.73 137.657L1084.05 138.1L1084.04 138.906L1083.99 144.183L1079.27 141.815L1078.55 141.453L1077.85 141.848L1073.25 144.436L1072.94 139.168L1072.89 138.364L1072.2 137.953L1067.66 135.264L1072.07 132.364L1072.74 131.921L1072.75 131.115L1072.81 125.838L1077.52 128.206L1078.24 128.568L1078.95 128.173L1083.55 125.585Z",
    stroke: "#091C4A",
    strokeWidth: 3.0296
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M374.424 121.68L296.487 113.408H375.711C375.098 115.859 374.669 118.616 374.424 121.68ZM380.674 95.7616L377.917 103.849L301.633 95.7616H380.674ZM374.424 131.054C374.669 134.363 375.16 137.12 375.895 139.326L298.141 131.054H374.424ZM400.159 156.972L302.92 148.7H382.145C386.189 152.622 392.193 155.379 400.159 156.972ZM394.46 78.1153C391.642 79.9535 388.946 82.4656 386.372 85.6518L315.42 78.1153H394.46ZM299.795 166.347H368.542L365.785 174.435L299.795 166.347ZM296.67 184.177H362.66L359.903 192.265L296.67 184.177ZM376.446 160.648C386.74 163.467 396.115 164.876 404.57 164.876C413.148 164.876 420.133 164.509 425.525 163.773L426.996 154.583L411.739 153.112C400.097 152.009 391.826 149.374 386.924 145.208C382.145 141.041 379.755 135.159 379.755 127.562C379.755 124.253 380.123 120.577 380.858 116.533C383.676 100.847 388.823 90.0633 396.298 84.1812C403.774 78.2991 415.231 75.3581 430.672 75.3581C446.235 75.3581 459.96 76.8899 471.847 79.9535L462.288 109.364C451.627 107.526 443.049 106.607 436.554 106.607C430.182 106.607 424.667 106.913 420.011 107.526L418.54 116.533L430.856 117.819C443.355 119.167 452.24 122.17 457.509 126.826C462.778 131.361 465.413 137.488 465.413 145.208C465.413 153.051 463.759 161.139 460.45 169.472C458.612 173.761 456.651 177.376 454.568 180.317C452.607 183.135 450.034 185.586 446.848 187.669C443.784 189.63 440.966 191.162 438.392 192.265C435.819 193.245 432.51 193.98 428.466 194.471C422.829 195.328 415.844 195.757 407.511 195.757C392.316 195.757 378.53 194.164 366.153 190.978L376.446 160.648ZM556.007 146.495L556.191 143.002H554.72L546.081 193H511.156L531.376 78.1153H566.3L558.029 124.988H559.499C560.48 121.067 561.583 118.126 562.808 116.165L585.969 78.1153H623.651L587.623 134.547L604.35 193H566.668L556.558 151.825C556.191 150.6 556.007 148.823 556.007 146.495ZM505.641 192.449L427.704 184.177H507.112L505.641 192.449ZM511.891 156.972L433.953 148.7H513.362L511.891 156.972ZM515.016 139.326L437.078 131.054H516.486L515.016 139.326ZM518.141 121.68L440.203 113.408H519.611L518.141 121.68ZM521.266 104.033L443.328 95.7616H522.552L521.266 104.033ZM508.766 174.618L430.828 166.347H510.237L508.766 174.618ZM524.207 86.387L446.453 78.1153H525.677L524.207 86.387ZM658.297 192.449L580.543 184.177H659.768L658.297 192.449ZM661.422 174.618L583.668 166.347H662.709L661.422 174.618ZM662.709 156.972L584.771 148.7H661.054L662.709 156.972ZM659.216 139.326L581.279 131.054H657.562L659.216 139.326ZM650.577 95.7616L652.231 104.033L574.477 95.7616H650.577ZM654.069 113.408L655.724 121.68L577.97 113.408H654.069ZM648.923 86.387L571.169 78.1153H647.268L648.923 86.387ZM691.384 78.1153L693.774 118.555H695.06L711.971 78.1153H750.573L704.251 161.751L698.92 193H663.995L669.326 161.751L652.783 78.1153H691.384ZM783.162 121.68L705.225 113.408H784.449C783.836 115.859 783.408 118.616 783.162 121.68ZM789.412 95.7616L786.655 103.849L710.372 95.7616H789.412ZM783.162 131.054C783.408 134.363 783.898 137.12 784.633 139.326L706.879 131.054H783.162ZM808.897 156.972L711.658 148.7H790.883C794.927 152.622 800.931 155.379 808.897 156.972ZM803.198 78.1153C800.38 79.9535 797.684 82.4656 795.11 85.6518L724.158 78.1153H803.198ZM708.533 166.347H777.28L774.523 174.435L708.533 166.347ZM705.409 184.177H771.398L768.641 192.265L705.409 184.177ZM785.184 160.648C795.478 163.467 804.853 164.876 813.308 164.876C821.886 164.876 828.871 164.509 834.263 163.773L835.734 154.583L820.477 153.112C808.835 152.009 800.564 149.374 795.662 145.208C790.883 141.041 788.493 135.159 788.493 127.562C788.493 124.253 788.861 120.577 789.596 116.533C792.415 100.847 797.561 90.0633 805.037 84.1812C812.512 78.2991 823.97 75.3581 839.41 75.3581C854.973 75.3581 868.698 76.8899 880.585 79.9535L871.026 109.364C860.365 107.526 851.787 106.607 845.292 106.607C838.92 106.607 833.405 106.913 828.749 107.526L827.278 116.533L839.594 117.819C852.093 119.167 860.978 122.17 866.247 126.826C871.516 131.361 874.151 137.488 874.151 145.208C874.151 153.051 872.497 161.139 869.188 169.472C867.35 173.761 865.389 177.376 863.306 180.317C861.345 183.135 858.772 185.586 855.586 187.669C852.522 189.63 849.704 191.162 847.13 192.265C844.557 193.245 841.248 193.98 837.204 194.471C831.567 195.328 824.582 195.757 816.249 195.757C801.054 195.757 787.268 194.164 774.891 190.978L785.184 160.648ZM917.688 134.73C917.443 135.711 917.198 137.059 916.953 138.774L844.713 131.054H918.24L917.688 134.73ZM915.666 148.7C915.299 151.519 915.115 154.092 915.115 156.421L842.691 148.7H915.666ZM922.651 113.408L920.445 120.944L849.125 113.408H922.651ZM915.299 166.347C915.789 169.778 916.218 172.351 916.585 174.067L845.081 166.347H915.299ZM930.188 95.7616C928.472 98.9478 927.247 101.399 926.511 103.114L857.764 95.7616H930.188ZM920.813 184.177C922.406 186.995 924.244 189.262 926.327 190.978L862.727 184.177H920.813ZM947.65 78.1153C944.096 80.3211 941.339 82.3431 939.378 84.1812L883.131 78.1153H947.65ZM963.826 195.757C948.385 195.757 937.295 192.755 930.555 186.75C923.938 180.746 920.629 171.494 920.629 158.994C920.629 153.725 921.487 145.943 923.203 135.65C926.879 114.572 933.19 99.2541 942.136 89.6957C951.204 80.1373 965.48 75.3581 984.965 75.3581C989.499 75.3581 994.646 75.8483 1000.41 76.8286C1006.29 77.6864 1010.58 78.7893 1013.27 80.1373L1002.98 108.261C995.748 106.545 988.947 105.688 982.575 105.688C976.325 105.688 971.852 106.3 969.156 107.526C966.461 108.751 964.806 111.202 964.193 114.878L955.738 163.038C960.15 164.018 964.684 164.509 969.34 164.509C979.266 164.509 988.335 163.038 996.545 160.097L993.604 190.978C985.761 194.164 975.835 195.757 963.826 195.757ZM1255.06 165.244H1232.27L1227.49 193H1192.57L1212.79 78.1153H1267.93C1288.76 78.1153 1299.18 87.7963 1299.18 107.158C1299.18 116.349 1297.89 124.682 1295.32 132.157C1292.74 139.51 1289.87 145.392 1286.68 149.803C1283.62 154.092 1279.33 157.769 1273.81 160.832C1268.42 163.773 1262.17 165.244 1255.06 165.244ZM1245.5 135.833C1249.67 135.833 1252.8 135.404 1254.88 134.547C1257.08 133.566 1258.49 131.422 1259.11 128.113C1260.7 119.045 1261.5 114.082 1261.5 113.224C1261.5 110.896 1260.58 109.364 1258.74 108.629C1256.9 107.893 1254.14 107.526 1250.47 107.526H1242.38L1237.42 135.833H1245.5ZM1187.05 192.449L1109.11 184.177H1188.52L1187.05 192.449ZM1193.3 156.972L1115.36 148.7H1194.77L1193.3 156.972ZM1199.37 121.68L1121.61 113.408H1200.84L1199.37 121.68ZM1202.49 104.033L1124.74 95.7616H1203.96L1202.49 104.033ZM1190.18 174.618L1112.24 166.347H1191.65L1190.18 174.618ZM1205.62 86.387L1127.86 78.1153H1207.09L1205.62 86.387ZM1196.24 139.326L1118.49 131.054H1197.71L1196.24 139.326ZM1411.22 149.62H1376.3L1373.91 163.59H1416.74L1411.59 193H1333.84L1354.06 78.1153H1430.89L1421.33 107.526H1383.65L1381.08 122.966H1416L1411.22 149.62ZM1328.32 192.449L1250.39 184.177H1329.79L1328.32 192.449ZM1334.57 156.972L1256.64 148.7H1336.04L1334.57 156.972ZM1337.7 139.326L1259.76 131.054H1339.17L1337.7 139.326ZM1340.82 121.68L1262.88 113.408H1342.29L1340.82 121.68ZM1343.95 104.033L1266.01 95.7616H1345.23L1343.95 104.033ZM1331.45 174.618L1253.51 166.347H1332.92L1331.45 174.618ZM1346.89 86.387L1269.13 78.1153H1348.36L1346.89 86.387Z",
    fill: "#000749"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3fa9e3a433c3179d3b7dfc634d983aa8.svg";
export { ForwardRef as ReactComponent };